import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { me } from '../../initial_state'
import PanelLayout from './panel_layout'
import Button from '../button'
import Icon from '../icon'
import Text from '../text'
import { MODAL_PRO_UPGRADE } from '../../constants'
import { openModal } from '../../actions/modal'

class ProPanel extends React.PureComponent {

  handleOnOpenProUpgradeModal = () => {
    const { subtitle } = this.props
    this.props.dispatch(openModal(MODAL_PRO_UPGRADE, { subtitle }))
  }

  render() {
    const { isPro, message } = this.props

    if (isPro) return null

    const title = (
      <span className={[_s.d, _s.flexRow, _s.jcCenter, _s.aiCenter].join(' ')}>
        <span className={[_s.d, _s.mr2].join(' ')}>
          Upgrade to Gab
        </span>
        <span className={[_s.bgPro, _s.cBlack, _s.radiusSmall, _s.px5, _s.py5].join(' ')}>PRO</span>
      </span>
    )

    return (
      <PanelLayout
        title={title}
        subtitle={message || "Please consider supporting us on our mission to defend free expression online for all people."}
      >

        <div className={[_s.d, _s.flexRow, _s.pb5].join(' ')}>
          <Button
            radiusSmall
            onClick={this.handleOnOpenProUpgradeModal}
            className={[_s.flexRow, _s.flexGrow1, _s.aiCenter, _s.jcCenter].join(' ')}
          >
            <Text color='inherit' size='large' weight='bold' align='center'>
              Upgrade Now
            </Text>
            <Icon id='arrow-right' size='20px' className={[_s.cWhite, _s.ml5].join(' ')} />
          </Button>
        </div>

      </PanelLayout>
    )
  }

}

ProPanel.propTypes = {
  isPro: PropTypes.bool.isRequired,
}

const mapStateToProps = (state) => ({
  isPro: state.getIn(['accounts', me, 'is_pro']),
})

export default connect(mapStateToProps)(ProPanel)
